import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFireFlame = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.182 17.966C22.182 17.966 23.125 12.412 19.273 10C19.2155 10.9542 18.9574 11.8856 18.5156 12.7334C18.0738 13.5811 17.4582 14.3262 16.709 14.92C15.063 16.368 11.967 19.616 12 23.089C11.989 24.5714 12.392 26.0274 13.1637 27.2931C13.9355 28.5588 15.0452 29.5839 16.368 30.253C16.4156 29.5836 16.5962 28.9304 16.8992 28.3317C17.2023 27.7329 17.6217 27.2007 18.133 26.766C18.5665 26.4329 18.9293 26.0167 19.2 25.5418C19.4708 25.0669 19.6442 24.5427 19.71 24C20.8433 24.602 21.8009 25.4879 22.4891 26.571C23.1773 27.6541 23.5725 28.8973 23.636 30.179V30.2C24.8843 29.6272 25.95 28.7204 26.7152 27.5798C27.4804 26.4392 27.9154 25.1093 27.972 23.737C28.056 20.9198 27.1091 18.1687 25.309 16",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgFireFlame);
export default ForwardRef;
